export default __webpack_public_path__ + "static/media/visa-card-selected.373fe070.svg";